import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import VueProgressBar from "@aacassandra/vue3-progressbar";

const options = {
    color: "#EE6C4D",
    failedColor: "#874b4b",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
    autoFinish: false
};

// import "bootstrap/dist/css/bootstrap.min.css"
import '@/assets/css/bootstrap-custom.scss';
import "bootstrap"
import './assets/css/main.css'

const app = createApp(App).use(store).use(router).use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAjsKG4VqZ6Y13CBhW7APM77qiSBaVtwzE',
        language: 'ka',
    },
}).use(VueProgressBar, options).mount('#app')

export default app
